import moment from 'moment';
import getOffsetTime from '../../../../../utils/getOffsetTime';

const addDayType = (itemDetails, dayTypesAll) => {
  // creating dayTypes must by definition be off-time thus no tours, dayOff field is populated
  const { date, dayTypeId, dayTypeComment, myDayTypeComment } = itemDetails;
  const tempDayTypeId = `${Math.floor(Math.random() * (19999999 - 10000000 + 1)) + 10000000}-optimistic`;
  const title = dayTypesAll
    .find((elem) => {
      return dayTypeId == elem.dayTypeId;
    }).dayTypeName;
    // address cloud server utc time offset (4 hours)
  let startTime = moment(date).startOf('day').clone().add(-4, 'hours').unix();
  let endTime = moment(date).endOf('day').clone().add(-4, 'hours').unix();

  // NOTE: Trying to Address defect 1954 but ==> NEW BUG!!
  // let startTime = moment(date).startOf('day');
  // let endTime = moment(date).endOf('day');
  // let timeZoneOffset = getOffsetTime(date._d);
  // startTime = startTime.subtract(timeZoneOffset, 'minutes').unix();
  // endTime = endTime.subtract(timeZoneOffset , 'minutes').unix();

  const dayType = {
    rdtId: tempDayTypeId,
    title,
    rdtComment: dayTypeComment || " ",
    myDayComment: myDayTypeComment || " ",
    dayOff: {
      dorId: dayTypeId,  // not sure this is accurate
      title,
      startTime,
      endTime,
      comment: dayTypeComment || " "
    }
  };
  return dayType;
}

export default addDayType;



// WEBPACK FOOTER //
// ./src/Components/Schedule/LiveScheduleUpdate/utils/generateNewOptimisticItems/addDayType.js